import http from "../mpm-config/http-common";

class Refs {

    async findAll() {
        return [
            { key: 1, text: "EXTRANET", value: "EXTRANET" }
        ]
    }

    async getAllEntities() {
        return http(window.keycloak.token).get("/entites").then(res => res.data);
    }

    async getAllTypesTransformation() {
        return http(window.keycloak.token).get("/typeTransformation").then(res => res.data);
    }

    async getAllPays() {
        return http(window.keycloak.token).get("/pays").then(res => res.data);
    }

    async update(id, data) {
        return http(window.keycloak.token).put(`/entite-rattachement/${id}`, data);
    }
}

export default new Refs();